import React, { useEffect, useState } from "react";
import { TableContainer, Paper, TextField, Button } from "@mui/material";
import { Typography } from "@mui/material";
import Grid from "@mui/material/Grid";

import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import PaidIcon from "@mui/icons-material/Paid";

// material-ui
import Box from "@mui/material/Box";
import { Link } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { useParams } from "react-router-dom";

import { Get_All_From_Xero } from "../api/Get_All_From_Xero";
import { Test_One_Xero } from "../api/Test_One_Xero";
import { Get_All_From_MongoDB } from "../../../api/Get_All_From_MongoDB";
import { Post_To_MongoDB } from "../../../api/Post_To_MongoDB";
import { Update_To_MongoDB_By_ID } from "../../../api/Update_To_MongoDB_By_ID";
import SimpleTableHeader from "../../../components/Tables/SimpleTableHeader";
import { Get_One_From_MongoDB } from "../../../api/Get_One_From_MongoDB";
import { Get_limited_Choose_Fields_With_Sort_From_MongoDB } from "../../../api/Get_limited_Choose_Fields_With_Sort_From_MongoDB";
import { Update_To_MongoDB_Push_To_Array_By_ID } from "../../../api/Update_To_MongoDB_Push_To_Array_By_ID";
import SearchSetRegisters from "../../../components/Search/SearchSetRegisters";
import { Delete_One_From_MongoDB } from "../../../api/Delete_One_From_MongoDB";
import { StaffuseAuth } from "../../../security/StaffuseAuth";
import Notes from "./components/Notes";
import { Get_All_From_Array_Of_Object_IDs_From_MongoDB } from "../../../api/Get_All_From_Array_Of_Object_IDs_From_MongoDB";
import { Send_Invoice_Paid_Confirmation_Emails } from "../api/Send_Invoice_Paid_Confirmation_Emails";

// material-ui

function ViewInvoice() {
  const { logout } = StaffuseAuth();

  const { id } = useParams();
  useEffect(() => {
    if (id !== "AddInvoice") {
      Get_One_From_MongoDB("Invoices", "Xero_2025", id, setInvoice, logout);
    }
  }, []);
  const [Invoice, setInvoice] = useState({
    _id: id,
    DateTime: new Date().toISOString(),
    Invoice_Number: "",
    Staff_id: localStorage.getItem("_id"),
    Amount: "",
    DiscountCode: "",
    Paid_Status: "UnPaid",
    Paid_Date: "",
    Due_Date: "",
    CreditNote_Used: "No",
    CreditNote_AmountUsed: "",
    CreditNote_Code: "",
    GrossOrNet: "Gross",
    Link: "",
    Attendees: [],
  });

  //The below gets the staff
  const [Staff, setStaff] = useState([]);
  useEffect(() => {
    Get_limited_Choose_Fields_With_Sort_From_MongoDB(
      "Staff",
      "Users",
      100,
      { Username: 1 },
      setStaff,
      {
        Username: 1,
        Team: 1,
        Level: 1,
        _id: 1,
      },
      logout
    );
  }, []);

  // Function to handle changing the state of Invoice
  const handlePaymentChange = (event) => {
    setInvoice({ ...Invoice, [event.target.name]: event.target.value });
  };
  const handlePaidStatusChange = (event) => {
    if (event.target.value === "UnPaid") {
      setInvoice({
        ...Invoice,
        [event.target.name]: event.target.value,
        Paid_Date: "",
      });
    } else if (event.target.value === "Paid") {
      setInvoice({
        ...Invoice,
        [event.target.name]: event.target.value,
        Paid_Date: new Date().toISOString().split("T")[0],
      });
    } else {
      setInvoice({
        ...Invoice,
        [event.target.name]: event.target.value,
      });
    }
  };

  //The below gets the Attendees
  const [ListAttendees, setListAttendees] = useState([]);
  useEffect(() => {
    //get an array of all Attendee_id from the Invoice.Attendees
    let ListIDs = [];
    if (
      Invoice.Attendees &&
      Array.isArray(Invoice.Attendees) &&
      Invoice.Attendees.length > 0
    ) {
      Invoice.Attendees.map((Attendee) => {
        ListIDs.push(Attendee.Attendee_id);
      });
      Get_All_From_Array_Of_Object_IDs_From_MongoDB(
        "Registers_2025",
        "All",
        ListIDs,
        setListAttendees,
        logout
      );
    }
  }, [Invoice.Attendees]);
  console.log("ListAttendees");
  console.log(ListAttendees);

  function getAttendeeName(id) {
    let Attendee = ListAttendees.find((Attendee) => Attendee._id === id);
    if (Attendee) {
      return Attendee.BasicInfo.First_Name + " " + Attendee.BasicInfo.Last_Name;
    } else {
      return "Not Found";
    }
  }

  const [isFormValid, setIsFormValid] = useState(false);
  //The below is the useEffect to check if the form is valid
  useEffect(() => {
    // Check if all required fields are filled out
    const checkFormValidity = () => {
      return (
        Invoice._id !== "" &&
        Invoice.DateTime !== "" &&
        Invoice.Invoice_Number !== "" &&
        Invoice.Amount !== "" &&
        Invoice.Paid_Status !== "" &&
        Invoice.Link !== "" &&
        // Invoice.Paid_Date !== "" &&
        Invoice.Due_Date !== ""
        // Invoice.CreditNote_Used !== "" &&
        // Invoice.CreditNote_AmountUsed !== ""
      );
    };

    setIsFormValid(checkFormValidity());
  }, [Invoice]); // This effect runs whenever the school state changes

  const [isSubmitting, setisSubmitting] = useState(false);

  function handleAddInvoice() {
    let data = Invoice;
    delete data._id;
    Post_To_MongoDB(data, "Invoices", "Xero_2025", setisSubmitting, logout);
  }

  function handleClearInvoice() {
    setInvoice({
      _id: id,
      DateTime: new Date().toISOString(),
      Invoice_Number: "",
      Staff_id: localStorage.getItem("_id"),
      Amount: "",
      DiscountCode: "",
      Paid_Status: "UnPaid",
      Paid_Date: "",
      Due_Date: "",
      CreditNote_Used: "No",
      CreditNote_AmountUsed: "",
      CreditNote_Code: "",
      GrossOrNet: "Gross",
      Link: "",
      Attendees: [],
    });
  }

  function handleUpdateInvoice() {
    let data = Invoice;
    delete data._id;
    Update_To_MongoDB_By_ID(
      data,
      "Invoices",
      "Xero_2025",
      setisSubmitting,
      id,
      logout
    );
  }

  function handleUpdateAndEmailConfirmInvoice() {
    let data = Invoice;
    delete data._id;
    Update_To_MongoDB_By_ID(
      data,
      "Invoices",
      "Xero_2025",
      setisSubmitting,
      id,
      logout
    );
    let newDoc = {
      DateTime: new Date().toISOString(),
      Note: "Confirmation Emailed",
      Staff_ID: localStorage.getItem("_id"),
    };
    Update_To_MongoDB_Push_To_Array_By_ID(
      "Invoices",
      "Xero_2025",
      newDoc,
      "Notes",
      id,
      logout
    );
    Send_Invoice_Paid_Confirmation_Emails(
      data,
      localStorage.getItem("_id"),
      logout
    );
  }
  const [Bool_ReadyToDelete, setBool_ReadyToDelete] = useState(false);
  function handleDeleteInvoice() {
    if (Bool_ReadyToDelete) {
      let data = Invoice;
      Delete_One_From_MongoDB(
        id,
        "Invoices",
        "Xero_2025",
        setisSubmitting,
        data,
        logout
      );
    } else {
      setBool_ReadyToDelete(true);
    }
  }

  const [newAttendeePayment, setnewAttendeePayment] = useState({
    Source: "",
    Attendee_id: "",
    SubAmount: "",
  });

  const handlenewAttendeePaymentChange = (event) => {
    setnewAttendeePayment({
      ...newAttendeePayment,
      [event.target.name]: event.target.value,
    });
  };

  const handlenewAttendeePaymentSourceChange = (event) => {
    setnewAttendeePayment({
      ...newAttendeePayment,
      [event.target.name]: event.target.value,
      Attendee_id: "",
      Attendee_id: "Other",
    });
  };

  const [Registers, setRegisters] = useState([]);

  function handleSelectAttendeeToAssign(prop) {
    setnewAttendeePayment({
      ...newAttendeePayment,
      Attendee_id: prop,
      Source: "AttendeeID",
    });
  }

  const handleSelectCreditNote_Used = (event) => {
    setInvoice({
      ...Invoice,
      [event.target.name]: event.target.value,
      CreditNote_AmountUsed: "",
      CreditNote_Code: "",
    });
  };

  const [isAssignFormValid, setisAssignFormValid] = useState(false);
  //The below is the useEffect to check if the form is valid
  useEffect(() => {
    // Check if all required fields are filled out
    const checkFormValidity = () => {
      return (
        newAttendeePayment.Attendee_id !== "" &&
        newAttendeePayment.SubAmount !== "" &&
        newAttendeePayment.Source !== ""
      );
    };

    setisAssignFormValid(checkFormValidity());
  }, [newAttendeePayment]); // This effect runs whenever the school state changes

  function handleAssignInvoice() {
    console.log("assign");
    //push the newAttendeePayment to the Attendees array in Invoice
    //check if the Attendees array exists and if it is an array
    if (Invoice.Attendees && Array.isArray(Invoice.Attendees)) {
      const updatedAssigns = [...Invoice.Attendees, newAttendeePayment];
      setInvoice({ ...Invoice, Attendees: updatedAssigns });
      setnewAttendeePayment({
        Attendee_id: "",
        SubAmount: "",
        Source: "",
      });
    } else {
      setInvoice({ ...Invoice, Attendees: [newAttendeePayment] });
      setnewAttendeePayment({
        Attendee_id: "",
        SubAmount: "",
        Source: "",
      });
    }
  }

  function handleDeleteAssignment(Attendee, index) {
    let temp = Invoice.Attendees;
    temp.splice(index, 1);
    setInvoice({ ...Invoice, Attendees: temp });
  }

  return (
    <div
      style={{
        backgroundColor: "#e5e5e5",
        minHeight: "93vh",
        paddingLeft: "10px",
      }}
    >
      <section>
        <h1 style={{ marginTop: "0px" }}>Invoices</h1>
        <h2>Add/Update Invoices</h2>
        {/* Basic Info */}
        <section>
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <TextField
                label="id"
                name="id"
                value={id}
                // onChange={handlePaymentChange}
                fullWidth
                sx={{ marginBottom: "10px" }}
                disabled={true}
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <TextField
                label="DateTime"
                name="DateTime"
                value={Invoice.DateTime}
                onChange={handlePaymentChange}
                fullWidth
                sx={{ marginBottom: "10px" }}
                disabled={true}
              />
              <TextField
                label="Due_Date"
                name="Due_Date"
                type="date"
                value={Invoice.Due_Date}
                onChange={handlePaymentChange}
                fullWidth
                sx={{ marginBottom: "10px" }}
                InputProps={{
                  style: {
                    backgroundColor: "white",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                label="Invoice_Number"
                name="Invoice_Number"
                value={Invoice.Invoice_Number}
                onChange={handlePaymentChange}
                fullWidth
                sx={{ marginBottom: "10px" }}
                InputProps={{
                  style: {
                    backgroundColor: "white",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <TextField
                label="Amount"
                name="Amount"
                type="number"
                onWheel={(e) => e.target.blur()}
                value={Invoice.Amount}
                onChange={handlePaymentChange}
                fullWidth
                sx={{ marginBottom: "10px" }}
                InputProps={{
                  style: {
                    backgroundColor: "white",
                  },
                }}
              />
              <TextField
                label="DiscountCode"
                name="DiscountCode"
                value={Invoice.DiscountCode}
                onChange={handlePaymentChange}
                fullWidth
                sx={{ marginBottom: "10px" }}
                InputProps={{
                  style: {
                    backgroundColor: "white",
                  },
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                label="Who Made Invoice"
                name="Staff_id"
                value={Invoice.Staff_id}
                onChange={handlePaymentChange}
                fullWidth
                sx={{ marginBottom: "10px" }}
                InputProps={{
                  style: {
                    backgroundColor: "white",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                select
              >
                {Staff.map((Obj_Staff) => (
                  <MenuItem key={Obj_Staff._id} value={Obj_Staff._id}>
                    {Obj_Staff.Username ? Obj_Staff.Username : ""}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                label="Paid_Status"
                name="Paid_Status"
                value={Invoice.Paid_Status}
                type="number"
                onWheel={(e) => e.target.blur()} // Specify that this TextField should accept numbers only
                onChange={handlePaidStatusChange}
                fullWidth
                sx={{ marginBottom: "10px" }}
                InputProps={{
                  style: {
                    backgroundColor: "white",
                  },
                }}
                select
              >
                <MenuItem value="Paid">Paid</MenuItem>
                <MenuItem value="UnPaid">UnPaid</MenuItem>
                <MenuItem value="Credited">Credited</MenuItem>
                <MenuItem value="Voided">Voided</MenuItem>
              </TextField>
              <TextField
                label="Paid_Date"
                name="Paid_Date"
                value={Invoice.Paid_Date}
                type="date" // Specify that this TextField should accept numbers only
                onChange={handlePaymentChange}
                fullWidth
                sx={{ marginBottom: "10px" }}
                InputProps={{
                  style: {
                    backgroundColor: "white",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                label="CreditNote_Used"
                name="CreditNote_Used"
                value={Invoice.CreditNote_Used}
                onChange={handleSelectCreditNote_Used}
                fullWidth
                sx={{ marginBottom: "10px" }}
                InputProps={{
                  style: {
                    backgroundColor: "white",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                select
              >
                <MenuItem value="No">No</MenuItem>
                <MenuItem value="Yes">Yes</MenuItem>
              </TextField>
              {Invoice.CreditNote_Used === "Yes" ? (
                <>
                  <TextField
                    label="CreditNote_AmountUsed"
                    name="CreditNote_AmountUsed"
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    value={Invoice.CreditNote_AmountUsed}
                    onChange={handlePaymentChange}
                    fullWidth
                    sx={{ marginBottom: "10px" }}
                    InputProps={{
                      style: {
                        backgroundColor: "white",
                      },
                    }}
                  />
                  <TextField
                    label="CreditNote_Code"
                    name="CreditNote_Code"
                    value={Invoice.CreditNote_Code}
                    onChange={handlePaymentChange}
                    fullWidth
                    sx={{ marginBottom: "10px" }}
                    InputProps={{
                      style: {
                        backgroundColor: "white",
                      },
                    }}
                  />
                </>
              ) : (
                <></>
              )}

              <TextField
                label="GrossOrNet"
                name="GrossOrNet"
                value={Invoice.GrossOrNet}
                onChange={handlePaymentChange}
                fullWidth
                sx={{ marginBottom: "10px" }}
                InputProps={{
                  style: {
                    backgroundColor: "white",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                select
              >
                <MenuItem value="Gross">Gross</MenuItem>
                <MenuItem value="Net">Net</MenuItem>
              </TextField>
              <TextField
                label="Link"
                name="Link"
                value={Invoice.Link}
                onChange={handlePaymentChange}
                fullWidth
                sx={{ marginBottom: "10px" }}
                InputProps={{
                  style: {
                    backgroundColor: "white",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
          </Grid>
          {Invoice.Attendees &&
          Array.isArray(Invoice.Attendees) &&
          Invoice.Attendees.length > 0 ? (
            <>
              <Typography variant="h6" gutterBottom>
                See Assignments
              </Typography>
              <TableContainer
                component={Paper}
                sx={{
                  width: "100%",
                  margin: "0 auto",
                  overflow: "auto",
                }}
              >
                <Table
                  aria-label="simple table"
                  sx={{
                    border: "1px solid #e0e0e0",
                    tableLayout: "fixed",
                  }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell
                        className="tableCellHeader" // Add this line to include the CSS class
                        align="left"
                        style={{
                          position: "sticky",
                          Top: 0,
                          zIndex: 1,
                          fontWeight: "bold", // Make Text bold
                          padding: "8px", // Adjust padding as needed To make cells smaller
                        }}
                      >
                        Attendee _id
                      </TableCell>
                      <TableCell
                        className="tableCellHeader" // Add this line to include the CSS class
                        align="left"
                        style={{
                          position: "sticky",
                          Top: 0,
                          zIndex: 1,
                          fontWeight: "bold", // Make Text bold
                          padding: "8px", // Adjust padding as needed To make cells smaller
                        }}
                      >
                        Source
                      </TableCell>
                      <TableCell
                        className="tableCellHeader" // Add this line to include the CSS class
                        align="left"
                        style={{
                          position: "sticky",
                          Top: 0,
                          zIndex: 1,
                          fontWeight: "bold", // Make Text bold
                          padding: "8px", // Adjust padding as needed To make cells smaller
                        }}
                      >
                        Attendee Name
                      </TableCell>
                      <TableCell
                        className="tableCellHeader" // Add this line to include the CSS class
                        align="left"
                        style={{
                          position: "sticky",
                          Top: 0,
                          zIndex: 1,
                          fontWeight: "bold", // Make Text bold
                          padding: "8px", // Adjust padding as needed To make cells smaller
                        }}
                      >
                        Sub Total
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {Invoice.Attendees && Array.isArray(Invoice.Attendees) ? (
                      Invoice.Attendees.map((Attendee, index) => (
                        <TableRow
                          key={index}
                          sx={{
                            "&:hover": {
                              backgroundColor: "rgba(169, 169, 169, 0.8)", // Dark grey color
                              "& .MuiTableCell-root": {
                                padding: "8px",
                                wordWrap: "break-word",
                                overflowWrap: "break-word", // Adjust padding here to make cells smaller
                              },
                            },
                          }}
                        >
                          <TableCell
                            component="th"
                            scope="row"
                            sx={{
                              padding: "8px",
                              wordWrap: "break-word",
                              overflowWrap: "break-word",
                            }}
                          >
                            {Attendee.Attendee_id}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            sx={{
                              padding: "8px",
                              wordWrap: "break-word",
                              overflowWrap: "break-word",
                            }}
                          >
                            {Attendee.Source}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            sx={{
                              padding: "8px",
                              wordWrap: "break-word",
                              overflowWrap: "break-word",
                            }}
                          >
                            {getAttendeeName(Attendee.Attendee_id)}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            sx={{
                              padding: "8px",
                              wordWrap: "break-word",
                              overflowWrap: "break-word",
                            }}
                          >
                            {Attendee.SubAmount}
                          </TableCell>
                          <TableCell
                            align="left"
                            sx={{
                              padding: "8px",
                              wordWrap: "break-word",
                              overflowWrap: "break-word",
                            }}
                          >
                            <Link
                              to={`/Staff/ViewAttendee/${Attendee.Attendee_id}`}
                              style={{
                                textDecoration: "none",
                                color: "inherit",
                              }}
                            >
                              <button>Go To Attendee</button>
                            </Link>
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            sx={{
                              padding: "8px",
                              wordWrap: "break-word",
                              overflowWrap: "break-word",
                            }}
                          >
                            <Button
                              variant="contained"
                              sx={{
                                backgroundColor: "red",
                                "&:hover": { backgroundColor: "darkred" },
                              }}
                              onClick={() =>
                                handleDeleteAssignment(Attendee, index)
                              }
                            >
                              Delete
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <></>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          ) : (
            <>
              {" "}
              <br></br>
              <Typography variant="h6" gutterBottom>
                No Assignments Yet
              </Typography>
              <br></br>
            </>
          )}
          <br></br>
          <div
            style={{
              width: "100%",
              height: "3px",
              backgroundColor: "black", // Change to true black
              margin: "0 auto", // Center the div
            }}
          />
        </section>
        <h2>Assign Payments to Attendees</h2>
        <section>
          <div
            style={{
              display: "flex",
              flexDirection: "row", // Add this line
              flexWrap: "wrap",
              justifyContent: "space-around",
              // gap: "20px",
              // height: "100%",
            }}
          >
            <SearchSetRegisters setRegisters={setRegisters} />
            <Grid item xs={6}>
              <TextField
                label="Source"
                name="Source"
                // disabled={true}
                value={newAttendeePayment.Source}
                onChange={handlenewAttendeePaymentSourceChange}
                fullWidth
                sx={{ marginBottom: "10px" }}
                InputLabelProps={{
                  shrink: true,
                }}
                style={{ width: "150px" }}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Attendee_id"
                name="Attendee_id"
                disabled={true}
                value={newAttendeePayment.Attendee_id}
                onChange={handlenewAttendeePaymentChange}
                fullWidth
                sx={{ marginBottom: "10px" }}
                InputLabelProps={{
                  shrink: true,
                }}
                style={{ width: "150px" }}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="SubAmount"
                name="SubAmount"
                type="number"
                onWheel={(e) => e.target.blur()}
                value={newAttendeePayment.SubAmount}
                onChange={handlenewAttendeePaymentChange}
                fullWidth
                sx={{ marginBottom: "10px" }}
                InputLabelProps={{
                  shrink: true,
                }}
                style={{ width: "150px" }}
              />
            </Grid>
          </div>
          <div>
            <Box
              component="main"
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                maxWidth: "95%",
                maxHeight: "400px",
                flexGrow: 1,
                p: 1,
              }}
            >
              <Typography variant="h6" gutterBottom>
                Choose Attendee
              </Typography>
              <TableContainer
                component={Paper}
                sx={{
                  width: "100%",
                  margin: "0 auto",
                  overflow: "auto",
                }}
              >
                <Table
                  aria-label="simple table"
                  sx={{
                    border: "1px solid #e0e0e0",
                    tableLayout: "fixed",
                  }}
                >
                  <TableHead>
                    <TableRow>
                      {SimpleTableHeader("_id")}
                      {SimpleTableHeader("Create Date")}
                      {SimpleTableHeader("First Name")}
                      {SimpleTableHeader("Last Name")}
                      {SimpleTableHeader("Email")}
                      {SimpleTableHeader("Programme Title")}
                      {SimpleTableHeader("Programme Date")}
                      {SimpleTableHeader("Programme Varient")}
                      {SimpleTableHeader("Choose")}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {Registers.map((Register, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          backgroundColor:
                            Register?.MetaData?.Reserved === "Yes"
                              ? "rgba(0, 0, 139, 0.5)"
                              : Register?.MetaData?.Archived === "Yes"
                              ? "rgba(139, 0, 0, 0.5)"
                              : "",
                          "&:hover": {
                            backgroundColor: "rgba(169, 169, 169, 0.8)", // Dark grey color
                            "& .MuiTableCell-root": {
                              padding: "8px",
                              wordWrap: "break-word",
                              overflowWrap: "break-word", // Adjust padding here to make cells smaller
                            },
                          },
                        }}
                      >
                        <>
                          <TableCell
                            component="th"
                            scope="row"
                            sx={{
                              padding: "8px",
                              wordWrap: "break-word",
                              overflowWrap: "break-word",
                            }}
                          >
                            {Register._id}
                          </TableCell>
                        </>
                        <>
                          <TableCell
                            component="th"
                            scope="row"
                            sx={{
                              padding: "8px",
                              wordWrap: "break-word",
                              overflowWrap: "break-word",
                            }}
                          >
                            {Register.BasicInfo.Created_At}
                          </TableCell>
                        </>
                        <>
                          <TableCell
                            component="th"
                            scope="row"
                            sx={{
                              padding: "8px",
                              wordWrap: "break-word",
                              overflowWrap: "break-word",
                            }}
                          >
                            {Register.BasicInfo.First_Name}
                          </TableCell>
                        </>
                        <>
                          <TableCell
                            component="th"
                            scope="row"
                            sx={{
                              padding: "8px",
                              wordWrap: "break-word",
                              overflowWrap: "break-word",
                            }}
                          >
                            {Register.BasicInfo.Last_Name}
                          </TableCell>
                        </>
                        <>
                          <TableCell
                            component="th"
                            scope="row"
                            sx={{
                              padding: "8px",
                              wordWrap: "break-word",
                              overflowWrap: "break-word",
                            }}
                          >
                            {Register.BasicInfo.Email}
                          </TableCell>
                        </>
                        <>
                          <TableCell
                            component="th"
                            scope="row"
                            sx={{
                              padding: "8px",
                              wordWrap: "break-word",
                              overflowWrap: "break-word",
                            }}
                          >
                            {Register.BasicInfo.ProgrammeTitle}
                          </TableCell>
                        </>
                        <>
                          <TableCell
                            component="th"
                            scope="row"
                            sx={{
                              padding: "8px",
                              wordWrap: "break-word",
                              overflowWrap: "break-word",
                            }}
                          >
                            {Register.BasicInfo.ProgrammeDate}
                          </TableCell>
                        </>
                        <>
                          <TableCell
                            component="th"
                            scope="row"
                            sx={{
                              padding: "8px",
                              wordWrap: "break-word",
                              overflowWrap: "break-word",
                            }}
                          >
                            {Register.BasicInfo.ProgrammeVarient}
                          </TableCell>
                        </>
                        <>
                          <TableCell
                            component="th"
                            scope="row"
                            sx={{
                              padding: "8px",
                              wordWrap: "break-word",
                              overflowWrap: "break-word",
                            }}
                          >
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={() =>
                                handleSelectAttendeeToAssign(Register._id)
                              }
                            >
                              Choose
                            </Button>
                          </TableCell>
                        </>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>{" "}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "16px",
              }}
            >
              <Button
                variant="contained"
                color="primary"
                onClick={handleAssignInvoice}
                disabled={!isAssignFormValid}
                style={{ width: "50%" }}
              >
                Assign
              </Button>
            </div>
          </div>
          <br></br>
          <div
            style={{
              width: "100%",
              height: "3px",
              backgroundColor: "black", // Change to true black
              margin: "0 auto", // Center the div
            }}
          />
          <br></br>
          <Notes Invoice={Invoice} setInvoice={setInvoice} Staff={Staff} />
          <br></br>
          <div
            style={{
              width: "100%",
              height: "3px",
              backgroundColor: "black", // Change to true black
              margin: "0 auto", // Center the div
            }}
          />
          <br></br> <br></br> <br></br>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "16px",
            }}
          >
            {id === "AddInvoice" ? (
              <div style={{ width: "90%" }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleAddInvoice}
                  disabled={!isFormValid}
                  style={{ width: "50%" }}
                >
                  {isSubmitting ? "Submitting..." : "Add Invoice"}
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={handleClearInvoice}
                  style={{ width: "50%" }}
                >
                  {isSubmitting ? "Submitting..." : "Clear Invoice"}
                </Button>
              </div>
            ) : (
              <div style={{ width: "90%" }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleUpdateInvoice}
                  disabled={!isFormValid}
                  style={{ width: "100%" }}
                >
                  {isSubmitting ? "Submitting..." : "Update Invoice"}
                </Button>
                <br></br> <br></br>
                {Invoice.Paid_Status === "Paid" &&
                Invoice.Amount !== 950 &&
                Invoice.Amount !== "950" ? (
                  <>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleUpdateAndEmailConfirmInvoice}
                      disabled={!isFormValid}
                      style={{ width: "100%" }}
                    >
                      {isSubmitting
                        ? "Submitting..."
                        : "Update Invoice and Email Confirmation"}
                    </Button>
                    <br></br> <br></br>
                  </>
                ) : (
                  <></>
                )}
                <Button
                  variant="contained"
                  onClick={handleDeleteInvoice}
                  disabled={!isFormValid}
                  style={{ width: "100%" }}
                  sx={{
                    backgroundColor: "red",
                    "&:hover": { backgroundColor: "darkred" },
                  }}
                >
                  {isSubmitting
                    ? "Submitting..."
                    : Bool_ReadyToDelete
                    ? "Are You Sure?"
                    : "Delete Invoice"}
                </Button>
              </div>
            )}
          </div>
          <br></br>
        </section>
        <div style={{ marginTop: "20px" }}></div>
      </section>
    </div>
  );
}

export default ViewInvoice;
